<template>
  <div class="ds-form-group" v-auto-animate>
    <FormLabel
      v-if="label"
      :class="[ labelClass, { 'ds-form-group__label--hidden': labelHidden } ]"
      :for="idParsed"
      v-bind="{ isOptional, isRequired, dataTestId }"
    >
      {{ label }}
      <slot name="postfix" />
    </FormLabel>

    <slot :id="idParsed" />
  </div>
</template>

<script>
import htmlProps from '../htmlProps.js';
import FormLabel from './FormLabel.vue';

export default {
  name: 'FormGroup',
  mixins: [htmlProps],
  components: {
    FormLabel,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    label: {
      value: String,
      required: false,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    labelClass: {
      value: String,
      required: false,
      default: 'ds-form-group__label',
    },
    labelHidden: {
      type: Boolean,
      default: false,
    },
    isOptional: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    idParsed() {
      if (this.id) {
        return this.id;
      }
      return Math.floor(Math.random() * 1000000);
    },
  },
};
</script>

<style lang="scss">
@use "@sass/design-system/variables" as ds-variables;

.ds-form-group {
  margin-top: 16px;
}
.ds-form-group__label {
  margin-bottom: 4px;
}

.ds-form-group__label--hidden {
  visibility: hidden;
}
</style>
